/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AppPlatform } from '../models/AppPlatform';
import type { CreateAppChangelogRequest } from '../models/CreateAppChangelogRequest';
import type { UpdateAppChangelogRequest } from '../models/UpdateAppChangelogRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AppChangelogService {
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppChangelogs(
        requestBody: CreateAppChangelogRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app-changelogs',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param page
     * @param pageSize
     * @param search
     * @param platform
     * @returns any OK
     * @throws ApiError
     */
    public static getApiAppChangelogs(
        page: number = 1,
        pageSize: number = 20,
        search?: string,
        platform?: AppPlatform,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app-changelogs',
            query: {
                'Page': page,
                'PageSize': pageSize,
                'Search': search,
                'Platform': platform,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static putApiAppChangelogs(
        id: string,
        requestBody: UpdateAppChangelogRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/app-changelogs/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static getApiAppChangelogs1(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app-changelogs/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiAppChangelogs(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/app-changelogs/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param platform
     * @returns any OK
     * @throws ApiError
     */
    public static getApiAppChangelogsVersions(
        platform?: AppPlatform,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app-changelogs/versions',
            query: {
                'Platform': platform,
            },
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static getApiAppChangelogsHistory(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app-changelogs/{id}/history',
            path: {
                'id': id,
            },
        });
    }
}
